import ReactDOM from 'react-dom/client';
import './index.scss';
import './i18n/config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { injectStore } from './api/axios';

// Inject store into axios to access fresh Redux auth state without circular imports
injectStore(store.getState);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

reportWebVitals();
